import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect (): void {
    const toggleButtons: NodeListOf<HTMLElement> = this.element.querySelectorAll('.source-toggle')

    toggleButtons.forEach((button: HTMLElement) => {
      const targetId: string | null = button.getAttribute('data-target')

      if (targetId !== null && targetId !== '') {
        const targetElement: HTMLElement | null = document.getElementById(targetId)

        if (targetElement !== null) {
          button.setAttribute('data-collapsed', 'false')
        }
      }
    })
  }

  toggle (event: Event): void {
    const button = event.currentTarget as HTMLElement
    const targetId = button.getAttribute('data-target')

    if (targetId === null || targetId === '') return

    const targetElement = document.getElementById(targetId)
    if (targetElement == null) return

    const isCollapsed = button.getAttribute('data-collapsed') === 'true'
    const newState = !isCollapsed

    button.setAttribute('data-collapsed', newState.toString())

    const arrowIcon = button.querySelector('.arrow-icon') as HTMLElement
    if (arrowIcon !== null) {
      arrowIcon.style.transform = newState ? 'rotate(180deg)' : 'rotate(0deg)'
    }

    targetElement.style.display = newState ? 'none' : 'table-row-group'
  }
}
